<template>
  <div>
    <div class="text">
      <h5>{{ engine.name }} (<currency :value="engine.price"></currency>)</h5>
      <p v-if="engine.description">{{ engine.description }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
  import CatalogModelEngineMixin from '../mixins/CatalogModelEngine'

  export default {

      props: {
          engine: {
              type: Object,
              required: true
          },
      },

      data: function() {
        return {
        };
      }

    }
</script>